/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { GetTenantPricingApiV1UsagePricingGet200 } from '../models/getTenantPricingApiV1UsagePricingGet200';

import type { GetTenantUsageDetailedApiV1UsageDetailedGet200 } from '../models/getTenantUsageDetailedApiV1UsageDetailedGet200';

import type { GetTenantUsageDetailedApiV1UsageDetailedGetParams } from '../models/getTenantUsageDetailedApiV1UsageDetailedGetParams';

import type { GetTopUsersApiV1UsageTopUsersCategoryGet200 } from '../models/getTopUsersApiV1UsageTopUsersCategoryGet200';

import type { GetTopUsersApiV1UsageTopUsersCategoryGetParams } from '../models/getTopUsersApiV1UsageTopUsersCategoryGetParams';

import type { GetUsageSummaryApiV1UsageSummaryGet200 } from '../models/getUsageSummaryApiV1UsageSummaryGet200';

import type { GetUsageSummaryApiV1UsageSummaryGetParams } from '../models/getUsageSummaryApiV1UsageSummaryGetParams';

import type { GetUserUsageApiV1UsageUsersUserIdGet200 } from '../models/getUserUsageApiV1UsageUsersUserIdGet200';

import type { GetUserUsageApiV1UsageUsersUserIdGetParams } from '../models/getUserUsageApiV1UsageUsersUserIdGetParams';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { StorageUsage } from '../models/storageUsage';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get usage summary for the current tenant.
 * @summary Get Usage Summary
 */
export const getUsageSummaryApiV1UsageSummaryGet = (
  params?: GetUsageSummaryApiV1UsageSummaryGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GetUsageSummaryApiV1UsageSummaryGet200>({
    url: `/api/v1/usage/summary`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetUsageSummaryApiV1UsageSummaryGetQueryKey = (
  params?: GetUsageSummaryApiV1UsageSummaryGetParams
) => {
  return [`/api/v1/usage/summary`, ...(params ? [params] : [])] as const;
};

export const getGetUsageSummaryApiV1UsageSummaryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
  TError = HTTPValidationError
>(
  params?: GetUsageSummaryApiV1UsageSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUsageSummaryApiV1UsageSummaryGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>
  > = ({ signal }) => getUsageSummaryApiV1UsageSummaryGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUsageSummaryApiV1UsageSummaryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>
>;
export type GetUsageSummaryApiV1UsageSummaryGetQueryError = HTTPValidationError;

export function useGetUsageSummaryApiV1UsageSummaryGet<
  TData = Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
  TError = HTTPValidationError
>(
  params: undefined | GetUsageSummaryApiV1UsageSummaryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUsageSummaryApiV1UsageSummaryGet<
  TData = Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
  TError = HTTPValidationError
>(
  params?: GetUsageSummaryApiV1UsageSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
          TError,
          Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUsageSummaryApiV1UsageSummaryGet<
  TData = Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
  TError = HTTPValidationError
>(
  params?: GetUsageSummaryApiV1UsageSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Usage Summary
 */

export function useGetUsageSummaryApiV1UsageSummaryGet<
  TData = Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
  TError = HTTPValidationError
>(
  params?: GetUsageSummaryApiV1UsageSummaryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUsageSummaryApiV1UsageSummaryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUsageSummaryApiV1UsageSummaryGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Stored bytes vs. the configured storage ceiling for the current tenant.

Storage is a **level**, not a monthly flow, so it is not part of
``/summary`` (which is period-scoped). See
docs/platform/tenant-storage-quota-design.md.
 * @summary Get Storage Usage
 */
export const getStorageUsageApiV1UsageStorageGet = (signal?: AbortSignal) => {
  return customInstance<StorageUsage>({
    url: `/api/v1/usage/storage`,
    method: 'GET',
    signal
  });
};

export const getGetStorageUsageApiV1UsageStorageGetQueryKey = () => {
  return [`/api/v1/usage/storage`] as const;
};

export const getGetStorageUsageApiV1UsageStorageGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetStorageUsageApiV1UsageStorageGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>
  > = ({ signal }) => getStorageUsageApiV1UsageStorageGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetStorageUsageApiV1UsageStorageGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>
>;
export type GetStorageUsageApiV1UsageStorageGetQueryError = unknown;

export function useGetStorageUsageApiV1UsageStorageGet<
  TData = Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
          TError,
          Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetStorageUsageApiV1UsageStorageGet<
  TData = Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
          TError,
          Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetStorageUsageApiV1UsageStorageGet<
  TData = Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Storage Usage
 */

export function useGetStorageUsageApiV1UsageStorageGet<
  TData = Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStorageUsageApiV1UsageStorageGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetStorageUsageApiV1UsageStorageGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get usage for a specific user (admin only).
 * @summary Get User Usage
 */
export const getUserUsageApiV1UsageUsersUserIdGet = (
  userId: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GetUserUsageApiV1UsageUsersUserIdGet200>({
    url: `/api/v1/usage/users/${userId}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetUserUsageApiV1UsageUsersUserIdGetQueryKey = (
  userId?: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams
) => {
  return [
    `/api/v1/usage/users/${userId}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetUserUsageApiV1UsageUsersUserIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetUserUsageApiV1UsageUsersUserIdGetQueryKey(userId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>
  > = ({ signal }) =>
    getUserUsageApiV1UsageUsersUserIdGet(userId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetUserUsageApiV1UsageUsersUserIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>
>;
export type GetUserUsageApiV1UsageUsersUserIdGetQueryError =
  HTTPValidationError;

export function useGetUserUsageApiV1UsageUsersUserIdGet<
  TData = Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  params: undefined | GetUserUsageApiV1UsageUsersUserIdGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
          TError,
          Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserUsageApiV1UsageUsersUserIdGet<
  TData = Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
          TError,
          Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserUsageApiV1UsageUsersUserIdGet<
  TData = Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Usage
 */

export function useGetUserUsageApiV1UsageUsersUserIdGet<
  TData = Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
  TError = HTTPValidationError
>(
  userId: string,
  params?: GetUserUsageApiV1UsageUsersUserIdGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getUserUsageApiV1UsageUsersUserIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetUserUsageApiV1UsageUsersUserIdGetQueryOptions(
    userId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get top users by usage for a category (admin only).
 * @summary Get Top Users
 */
export const getTopUsersApiV1UsageTopUsersCategoryGet = (
  category: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GetTopUsersApiV1UsageTopUsersCategoryGet200>({
    url: `/api/v1/usage/top-users/${category}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTopUsersApiV1UsageTopUsersCategoryGetQueryKey = (
  category?: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams
) => {
  return [
    `/api/v1/usage/top-users/${category}`,
    ...(params ? [params] : [])
  ] as const;
};

export const getGetTopUsersApiV1UsageTopUsersCategoryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
  TError = HTTPValidationError
>(
  category: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTopUsersApiV1UsageTopUsersCategoryGetQueryKey(category, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>
  > = ({ signal }) =>
    getTopUsersApiV1UsageTopUsersCategoryGet(category, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!category,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTopUsersApiV1UsageTopUsersCategoryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>
>;
export type GetTopUsersApiV1UsageTopUsersCategoryGetQueryError =
  HTTPValidationError;

export function useGetTopUsersApiV1UsageTopUsersCategoryGet<
  TData = Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
  TError = HTTPValidationError
>(
  category: string,
  params: undefined | GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
          TError,
          Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTopUsersApiV1UsageTopUsersCategoryGet<
  TData = Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
  TError = HTTPValidationError
>(
  category: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
          TError,
          Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTopUsersApiV1UsageTopUsersCategoryGet<
  TData = Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
  TError = HTTPValidationError
>(
  category: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Top Users
 */

export function useGetTopUsersApiV1UsageTopUsersCategoryGet<
  TData = Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
  TError = HTTPValidationError
>(
  category: string,
  params?: GetTopUsersApiV1UsageTopUsersCategoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTopUsersApiV1UsageTopUsersCategoryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTopUsersApiV1UsageTopUsersCategoryGetQueryOptions(
    category,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed AI usage for the current tenant (admin only).

Groups by user, model, feature with token breakdowns and cost estimates.
Returns model pricing with tenant-specific markup applied.
 * @summary Get Tenant Usage Detailed
 */
export const getTenantUsageDetailedApiV1UsageDetailedGet = (
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  signal?: AbortSignal
) => {
  return customInstance<GetTenantUsageDetailedApiV1UsageDetailedGet200>({
    url: `/api/v1/usage/detailed`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetTenantUsageDetailedApiV1UsageDetailedGetQueryKey = (
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams
) => {
  return [`/api/v1/usage/detailed`, ...(params ? [params] : [])] as const;
};

export const getGetTenantUsageDetailedApiV1UsageDetailedGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTenantUsageDetailedApiV1UsageDetailedGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>
  > = ({ signal }) =>
    getTenantUsageDetailedApiV1UsageDetailedGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTenantUsageDetailedApiV1UsageDetailedGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>
  >;
export type GetTenantUsageDetailedApiV1UsageDetailedGetQueryError =
  HTTPValidationError;

export function useGetTenantUsageDetailedApiV1UsageDetailedGet<
  TData = Awaited<
    ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantUsageDetailedApiV1UsageDetailedGet<
  TData = Awaited<
    ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantUsageDetailedApiV1UsageDetailedGet<
  TData = Awaited<
    ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Usage Detailed
 */

export function useGetTenantUsageDetailedApiV1UsageDetailedGet<
  TData = Awaited<
    ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>
  >,
  TError = HTTPValidationError
>(
  params?: GetTenantUsageDetailedApiV1UsageDetailedGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantUsageDetailedApiV1UsageDetailedGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantUsageDetailedApiV1UsageDetailedGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get AI model pricing for the current tenant (with markup applied).
 * @summary Get Tenant Pricing
 */
export const getTenantPricingApiV1UsagePricingGet = (signal?: AbortSignal) => {
  return customInstance<GetTenantPricingApiV1UsagePricingGet200>({
    url: `/api/v1/usage/pricing`,
    method: 'GET',
    signal
  });
};

export const getGetTenantPricingApiV1UsagePricingGetQueryKey = () => {
  return [`/api/v1/usage/pricing`] as const;
};

export const getGetTenantPricingApiV1UsagePricingGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTenantPricingApiV1UsagePricingGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>
  > = ({ signal }) => getTenantPricingApiV1UsagePricingGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTenantPricingApiV1UsagePricingGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>
>;
export type GetTenantPricingApiV1UsagePricingGetQueryError = unknown;

export function useGetTenantPricingApiV1UsagePricingGet<
  TData = Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantPricingApiV1UsagePricingGet<
  TData = Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantPricingApiV1UsagePricingGet<
  TData = Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Pricing
 */

export function useGetTenantPricingApiV1UsagePricingGet<
  TData = Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantPricingApiV1UsagePricingGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantPricingApiV1UsagePricingGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
